import React from "react";
import { Routes, Route } from "react-router-dom";
import SubPage from "components/pages/equipment/sub-pages";
import type { TEquipment } from "components/equipment/helpers/equipment-types-helper";
import { PermissionGuard } from "components/permissions";
import { Pages } from "components/pages";
import Equipment from "components/equipment";

interface IEquipmentRouteProps
{
    equipment: TEquipment | undefined;
    equipmentsGroup: TEquipment[] | undefined;
    conditionCreate: boolean;
    lang: string;
}

const EquipmentRoute: React.FC<IEquipmentRouteProps> = ({
    equipment,
    equipmentsGroup,
    conditionCreate,
    lang,
}) =>
{
    return (
        <PermissionGuard
            permission={Equipment.Const.permissions.VIEW}
            fallback={<Pages.Page403 />}
        >
            <Routes>
                <Route path="/" element={
                    <SubPage.OverView
                        equipment={equipment}
                        equipmentsGroup={equipmentsGroup}
                        conditionCreate={conditionCreate}
                        lang={lang} />}
                />
                <Route path="/variations/page/:pageNum" element={<SubPage.Variations equipment={equipment} lang={lang} />} />
                <Route path="/variations/page" element={<SubPage.Variations equipment={equipment} lang={lang} />} />
                <Route path="/variations" element={<SubPage.Variations equipment={equipment} lang={lang} />} />
                <Route path="/substitude" element={<SubPage.Substitude equipment={equipment} lang={lang} />} />
            </Routes>
        </PermissionGuard>
    );
};

export default EquipmentRoute;
